export const handleUserName = (identity, fistName, lastName) => {
  if (identity === "user") {
    const fistNameLetter = fistName ? fistName.slice(0, 1).toUpperCase() : "";
    const lastNameLetter = lastName ? lastName.slice(0, 1).toUpperCase() : "";
    return `${fistNameLetter}${lastNameLetter}`;
  }
  return "C";
};
